<section class="overview-pane">
  <header class="overview-intro">
    <h1 class="overview-title">{{ 'APPOINTMENT-OVERVIEW.HISTORY.TITLE' | translate }}</h1>
    <p class="overview-description">{{ 'APPOINTMENT-OVERVIEW.HISTORY.WHAT-IS-DESCRIPTION' | translate }}</p>
  </header>
  @if ({
    history: historyAppointments$ | async,
    isAppointmentInit: isInit$ | async,
    isProfileInit: isProfileInit$ | async
    }; as appointments) {
    @if (appointments.isAppointmentInit || appointments.isProfileInit) {
      <div class="overview-loading">
        <img src="/assets/img/spinner/loader.gif" class="loader-spinner" alt="" />
        <span>{{ 'APPOINTMENT-OVERVIEW.APPOINTMENTS-LOADING' | translate }}</span>
      </div>
    }
    @if (appointments?.history?.length > 0 && !appointments.isProfileInit) {
      <div class="appointment-info-wrapper">
        <div class="content-wrapper" #itemsRef>
          @for (appointment of appointments?.history; track appointment) {
            <app-multi-user-appointment-info
              [appointment]="appointment"
              [appointmentInfoType]="HISTORY_APPOINTMENT_INFO_TYPE">
            </app-multi-user-appointment-info>
          }
        </div>
      </div>
    }
    @if (!appointments?.history?.length && !appointments.isAppointmentInit && !appointments.isProfileInit) {
      <div
        class="content-wrapper empty-appointments appointment-overview-wrapper">
        <p class="no-appointment-message">{{ 'APPOINTMENT-OVERVIEW.HISTORY.EMPTY-APPOINTMENTS' | translate }}</p>
      </div>
    }
    @if (appointments.history?.length && !appointments.isAppointmentInit && !appointments.isProfileInit) {
      <div class="overview-pagination">
        @if ((pagination$ | async); as pagination) {
          <ngb-pagination
            class="d-flex justify-content-center"
            [collectionSize]="pagination?.totalCount"
            [pageSize]="pagination?.pageSize"
            [page]="pagination?.pageNumber"
            [boundaryLinks]="true"
            [maxSize]="3"
            [rotate]="true"
            [ellipses]="false"
            (pageChange)="onPageChange($event)">
          </ngb-pagination>
        }
      </div>
    }
  }
</section>
